export const environment = {
  production: true,
  cdnBaseUrl: "https://cdn.ischoolconnect.com",
  landingPageUrl: "https://ischoolconnect.com",
  apiUrl: "https://via-prod-api-uc.ischoolconnect.com",
  studentLogrocketId: "comozl/student-dashboard-prod",
  advisorLogrocketId: "comozl/advisor-dashboard-prod",
  advisorBackendUrl: "https://prod-advisor-api.ischoolconnect.com"
};
